import MyLoginForm from "src/app/auth/components/MyLoginForm"
import { PromiseReturnType } from "blitz"
import login from "../../auth/mutations/login"

type Props = {
  onSuccess?: (user: PromiseReturnType<typeof login>) => void
}

export const StudioLoginPage = ({ onSuccess }: Props) => {
  return <MyLoginForm onSuccess={onSuccess} />
}
